module.exports = __webpack_public_path__ + "static/Kevin Pei.65d2fb49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Kevin Pei.jpg
// module id = 1220
// module chunks = 6166952557895